
export function arrayMoveItem(arr: any[], from: number, to: number) {
  arr.splice(to, 0, arr.splice(from, 1)[0]);
}

export function arraySwapItem(arr: any[], x: number, y: number) {
  const b = arr[x];
  arr[x] = arr[y];
  arr[y] = b;
  return arr;
}
